import { connect as formikConnect, Field } from 'formik';
import PropTypes from 'prop-types';
import React from 'react';

import { createBEM } from '../../../../lib/utils/css';
import { FormItemTypes } from '../constants';
import * as FormUtils from '../utils';

import { FormSelectComponents } from './constants';
import FormSelectDay from './FormSelectPartials/FormSelectDay';
import FormSelectMonth from './FormSelectPartials/FormSelectMonth';
import FormSelectYear from './FormSelectPartials/FormSelectYear';

import './FormSelect.scss';

/**
 * @param  {string} label - Title for select
 * @param  {string} component - FormSelectDay | FormSelectMonth | FormSelectYear | FormSelectExpiration | Default
 * @param  {object} inputAttributes - Provides data to create a select
 * @param  {Any} formik - Provided by formik connect
 */

class FormSelect extends React.Component {
  static propTypes = {
    label: PropTypes.node,
    component: PropTypes.string,
    type: PropTypes.string,
    inputAttributes: PropTypes.shape({
      name: PropTypes.string,
      qaTag: PropTypes.string,
      isDisabled: PropTypes.bool,
      options: PropTypes.arrayOf(
        PropTypes.shape({
          value: PropTypes.string,
          text: PropTypes.string,
        }),
      ),
    }),
    formik: PropTypes.object,
  };

  render() {
    const { formik, label, inputAttributes, component } = this.props;
    const { name, qaTag, options, isDisabled } = inputAttributes;
    const selectClasses = createBEM('Form__select', {
      error: FormUtils.shouldShowError(formik, name),
      disabled: !!isDisabled,
    });
    switch (component) {
      case FormSelectComponents.SELECT_DAY:
        return <FormSelectDay {...this.props} />;
      case FormSelectComponents.SELECT_MONTH:
        return <FormSelectMonth {...this.props} />;
      case FormSelectComponents.SELECT_YEAR:
        return <FormSelectYear {...this.props} />;
      default:
        return (
          <Field
            className={selectClasses}
            name={name}
            title={label}
            data-qa={qaTag}
            component={FormItemTypes.SELECT}
            disabled={isDisabled}
          >
            <option selected={true} disabled={true} hidden={true}></option>
            {options &&
              options.map((option, index) => {
                return (
                  <option data-qa={option.qaTag} value={option.value} key={index}>
                    {option.text}
                  </option>
                );
              })}
          </Field>
        );
    }
  }
}

export default formikConnect(FormSelect);
